module.exports = __webpack_public_path__ + "img/system-settings.0c2e2cd2.svg";